import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { Action } from '../../../../../../components/index';
import { getArticleVideoMasterRequest } from '../../../../../../store/modules/articles/actions';
import { DownloadIcon } from '../../../../../../components/icon/solid';
import { MediaStyles } from '../styles';
import { VideoRef } from '../../../../../../types/items';

type Props = {
  video: VideoRef | null;
};

const RequestMasterAction = ({ video }: Props) => {
  const classes = MediaStyles();
  const dispatch = useDispatch();

  const clickMasterRequestHandler = useCallback(() => {
    if (video) dispatch(getArticleVideoMasterRequest(video));
  }, [dispatch, video]);

  if (!video) return null;

  return (
    <Action
      icon={<DownloadIcon className={classes.actionIcon} />}
      title="Request Master"
      onClick={clickMasterRequestHandler}
    />
  );
};

export default RequestMasterAction;
